import React from 'react'
import PropTypes from 'prop-types'
import AccountIntegrationWelcome from './AccountIntegrationWelcome'
import AccountIntegrationSelector from './AccountIntegrationSelector'
import AccountIntegrationConnect from './AccountIntegrationConnect'

const AccountIntegration = ({signupProduct}) => {
  const initialPage = signupProduct === 'points_on_payments' ? 2 : 1
  const [currentPage, setCurrentPage] = React.useState(initialPage)
  const [accountingProvider, setAccountingProvider] = React.useState(null)

  const goToNextPage = () => {
    setCurrentPage(currentPage + 1)
  }

  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1)
  }

  return (
    <>
      {currentPage === 1 && (
        <AccountIntegrationWelcome goToNextPage={goToNextPage} />
      )}
      {currentPage === 2 && (
        <AccountIntegrationSelector
          goToNextPage={goToNextPage}
          accountingProvider={accountingProvider}
          setAccountingProvider={setAccountingProvider}
          signupProduct={signupProduct}
        />
      )}
      {currentPage === 3 && (
        <AccountIntegrationConnect
          accountingProvider={accountingProvider}
          goToPreviousPage={goToPreviousPage}
          signupProduct={signupProduct}
        />
      )}
    </>
  )
}

AccountIntegration.propTypes = {
  signupProduct: PropTypes.oneOf(['points_on_payments', 'payments_on_demand'])
    .isRequired,
}

export default AccountIntegration
